import React from 'react';
import { AppHeaderBackLink, AppHeaderCartLink } from './AppHeaderNavActions';
import { useAppHeaderNav } from './useAppHeaderNav';

const InlineActions: React.FC = () => {
  const { backPath, cartItemCount, showBackLink, showCart } = useAppHeaderNav();

  return (
    <div className="app-header app-header--inline">
      <div className="app-header__inner">
        <div className="app-header__start">
          {showBackLink && backPath && <AppHeaderBackLink backPath={backPath} showLabel />}
        </div>
        <div className="app-header__end">
          {showCart && <AppHeaderCartLink cartItemCount={cartItemCount} />}
        </div>
      </div>
    </div>
  );
};

export default InlineActions;
